export const childInterestOptions = [
  { id: 'colegios', label: 'Colegios', emoji: '🏫' },
  { id: 'viajes', label: 'Viajes', emoji: '✈️' },
  { id: 'deportes', label: 'Academias deportivas', emoji: '🏀' },
  { id: 'juegos', label: 'Juegos', emoji: '🎮' },
  { id: 'consejos', label: 'Consejos para niños', emoji: '🧩' },
  { id: 'ropa', label: 'Ropa', emoji: '👕' },
  { id: 'fiestas', label: 'Fiestas', emoji: '🎭' },
  { id: 'vacaciones', label: 'Vacaciones', emoji: '🏖️' },
  { id: 'salud', label: 'Salud y bienestar', emoji: '❤️' },
  { id: 'tareas', label: 'Tareas Dirigidas', emoji: '✏️' },
  { id: 'aprendizaje', label: 'Aprendizaje', emoji: '🎓' },
  { id: 'musica', label: 'Música', emoji: '🎵' },
  { id: 'parques', label: 'Parques', emoji: '🏞️' },
  { id: 'verano', label: 'Verano', emoji: '☀️' },
];

export const patientLinkOptions = [
  { id: 'hijo', label: 'Hijo / Hija' },
  { id: 'tutorizado', label: 'Tutorizado / a' },
  { id: 'yo_mismo', label: 'Soy yo el paciente' },
  { id: 'otro', label: 'Otro' },
];

export const emptyChildForm = () => ({
  id: null,
  nombre: '',
  documentoTipo: 'cedula',
  documentoNumero: '',
  vinculo: 'hijo',
  pais: '',
  fechaNacimiento: '',
  genero: '',
  intereses: [],
  planilla: null,
  planillaValores: {},
});

export const emptyPatientForm = emptyChildForm;

const extraerValoresPlanilla = (planilla) => {
  const valores = {};

  ((planilla && planilla.secciones) || []).forEach((seccion) => {
    (seccion.campos || []).forEach((campo) => {
      if (campo.clave) {
        valores[campo.clave] = campo.valor;
      }
    });
  });

  return valores;
};

export const mapChildFromApi = (child) => {
  if (!child) {
    return emptyChildForm();
  }

  return {
    id: child.id || null,
    nombre: child.nombre || '',
    documentoTipo: child.documento_tipo || 'cedula',
    documentoNumero: child.documento_numero || '',
    vinculo: child.vinculo || 'hijo',
    pais: child.pais || '',
    fechaNacimiento: child.fecha_nacimiento || '',
    genero: child.genero || '',
    intereses: Array.isArray(child.intereses) ? child.intereses : [],
    planilla: child.planilla || null,
    planillaValores: extraerValoresPlanilla(child.planilla),
  };
};

export const mapPatientFromApi = mapChildFromApi;

export const mapChildrenToPayload = (sinHijos, hijos) => {
  if (sinHijos) {
    return {
      sin_hijos: true,
      hijos: [],
    };
  }

  return {
    sin_hijos: false,
    hijos: (hijos || []).map((child) => ({
      id: child.id || null,
      nombre: (child.nombre || '').trim(),
      documento_tipo: child.documentoTipo || 'cedula',
      documento_numero: (child.documentoNumero || '').trim().toUpperCase(),
      vinculo: child.vinculo || 'hijo',
      pais: (child.pais || '').trim().toLowerCase(),
      fecha_nacimiento: child.fechaNacimiento || '',
      genero: child.genero || '',
      intereses: Array.isArray(child.intereses) ? child.intereses : [],
      planilla: {
        valores: child.planillaValores && typeof child.planillaValores === 'object' ? child.planillaValores : {},
      },
    })),
  };
};

export const mapPatientsToPayload = mapChildrenToPayload;

export const getPatientLinkLabel = (vinculo) => {
  const match = patientLinkOptions.find((item) => item.id === vinculo);
  return match ? match.label : 'Paciente';
};
